import { ReactNode } from 'react'
import { cn } from '@/utils/cn'

export interface EditorialListItem {
  title: ReactNode
  body?: ReactNode
  index?: string | number
}

interface EditorialListProps {
  items: EditorialListItem[]
  className?: string
  startAt?: number
}

export function EditorialList({ items, className, startAt = 1 }: EditorialListProps) {
  return (
    <div className={cn('eh-editorial-list eh-stagger', className)} role="list">
      {items.map((item, i) => {
        const num =
          item.index ?? String(startAt + i).padStart(2, '0')
        return (
          <article
            key={typeof item.title === 'string' ? item.title : i}
            className="eh-editorial-list__item eh-reveal"
            role="listitem"
          >
            <span className="eh-display text-[clamp(1.5rem,2.5vw,2rem)] leading-none text-eh-forest-ink">
              {num}
            </span>
            <div>
              <h3 className="eh-heading">{item.title}</h3>
              {item.body ? (
                <p className="mt-2 text-sm leading-relaxed text-eh-muted">{item.body}</p>
              ) : null}
            </div>
          </article>
        )
      })}
    </div>
  )
}

export default EditorialList
